import { axiosInstance } from "../../../api/axiosInstance";
import { ClassSubjectsData, ClassSubjectsSection } from "../types";

// The backend drops empty lists and nulls from JSON (jackson non_empty), so a class with no
// subjects or a grade with no sections arrives without the key - put the empty lists back.
const withSubjectCodes = (section: ClassSubjectsSection): ClassSubjectsSection => ({
  ...section,
  subjectCodes: section.subjectCodes ?? [],
});

// Subjects, and every grade with its classes and each class's subject codes — one call.
export const fetchClassSubjects = async (): Promise<ClassSubjectsData> => {
  const response = await axiosInstance.get<Partial<ClassSubjectsData>>("/class-subjects");
  return {
    subjects: response.data.subjects ?? [],
    grades: (response.data.grades ?? []).map((grade) => ({
      ...grade,
      sections: (grade.sections ?? []).map(withSubjectCodes),
    })),
  };
};

// Makes the class's subjects exactly `subjectCodes`; returns the class afterwards.
export const saveClassSubjects = async (
  gradeSectionId: number,
  subjectCodes: string[]
): Promise<ClassSubjectsSection> => {
  const response = await axiosInstance.put<ClassSubjectsSection>(
    `/class-subjects/${gradeSectionId}`,
    subjectCodes
  );
  return withSubjectCodes(response.data);
};
